import { EditListItemsResponse } from "@/features/list/hooks/useEditListItems";
import { createContext } from "react";

const EditListItemContext = createContext<EditListItemsResponse>({
  isEditing: false,
  isSelectedItem: () => {
    return false;
  },
  editHandler: () => {
    return;
  },
  editCompleteHandler: () => {
    return;
  },
  selectedItems: [],
  selectHandler: () => {
    return;
  },
  deleteHandler: () => {
    return;
  },
});

export default EditListItemContext;
